import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const TrashOutlineIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M4.365 12.667c0 .733.6 1.333 1.334 1.333h5.333c.733 0 1.333-.6 1.333-1.333v-8h-8v8ZM5.7 6h5.333v6.667H5.699V6Zm5-3.333L10.032 2H6.699l-.667.667H3.699V4h9.333V2.667h-2.333Z" />
  </Icon>
);

export default memo(TrashOutlineIcon);
